import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthorizatedGuard } from './services/guard';

import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { SigninComponent } from './signin/signin.component';
import { ContinueComponent } from './continue/continue.component';
import { Error401Component } from './error401/error401.component';
import { Error404Component } from './error404/error404.component';
import { WelcomeComponent } from './welcome/welcome.component';



const routes: Routes = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full'
  },
  {
    path: 'welcome',
    canActivate: [AuthorizatedGuard],
    component: WelcomeComponent,
    data: { permission: 'WELCOME' }
  },
  {
    path: 'signin',
    component: SigninComponent
  },
  {
    path: 'continue',
    component: ContinueComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthorizatedGuard],
    data: { permission: 'DASHBOARD' }
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthorizatedGuard],
    data: { permission: 'PROFILE' }
  },
  {
    path: '401',
    component: Error401Component
  },
  {
    path: '404',
    component: Error404Component
  },
  {
    path: 'website',
    loadChildren: () => import('./website/website.module').then(m => m.WebsiteModule)
  },
  {
    path: 'adblock',
    loadChildren: () => import('./adblock/adblock.module').then(m => m.AdBlockModule)
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  },
  {
    path: 'segmentation',
    loadChildren: () => import('./segmentation/segmentation.module').then(m => m.SegmentationModule)
  },
  {
    path: 'promo',
    loadChildren: () => import('./promotion/promotion.module').then(m => m.PromotionModule)
  },
  {
    path: 'richgraph',
    loadChildren: () => import('./richgraph/richgraph.module').then(m => m.RichgraphModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'emarketing',
    loadChildren: () => import('./emarketing/emarketing.module').then(m => m.EmarketingModule)
  },
  { path: '**', redirectTo: '404' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
